module.exports = __webpack_public_path__ + "static/img/kal-visuals-square.83531691.jpg";